/** A new P&P Slip (FC). Nothing is written -- and no number is spent -- until the first Post. */
import { PROCESSING_PACKING_FC_FORM } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { PnpFcPage } from "@/features/processing/components/pnp-fc-page";

export const Route = createFileRoute("/_app/processing/pnp-fc-slip/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(PROCESSING_PACKING_FC_FORM))
      throw redirect({ to: "/processing/pnp-fc-slip" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <PnpFcPage
      slip={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
